import { createListViewContainer } from 'factories/ListView'
import selectors from 'selectors'
import actions from 'actions/reports/jobCompletionSummaryReport'
import Component from 'components/Reports/JobCompletionSummaryReport'

export default createListViewContainer({ actions, selectors: selectors.jobCompletionSummaryReport })(Component)
